/**
 * @description Profile notifications types.
 */
export enum ProfileNotification {
  PlaidAccountPosted = 'PlaidAccountPosted',
  CustomerIDInvalid = 'CustomerIDInvalid'
}



// WEBPACK FOOTER //
// ./src/model/types/profile-notification-type.ts